module.exports = __webpack_public_path__ + "static/img/Opus_IVS_90h_extrawhite.324eb49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Opus_IVS_90h_extrawhite.png
// module id = lRYI
// module chunks = 31